module.exports = __webpack_public_path__ + "static/media/manage_icon.6c4dd4a7.png";